<template>
    <div class="weeklyTarget-contentBox">
        <div class="weeklyTarget-topBanner">
            <!-- Show when status 1 -->
            <router-link v-if="statusVal === 1" :to="`/weeklytarget_policy/token=${token}`">
                <img :src="weeklyTargetBanner" alt="" />
            </router-link>
            <!-- Show when status 3 -->
            <router-link v-else-if="statusVal === 3" :to="`/weeklytarget_policy_status3/token=${token}`">
                <img :src="weeklyTargetBanner" alt="" />
            </router-link>

            <!-- <router-link
                v-if="statusVal === 1"
                :to="{ name: 'WeeklyTargetPolicy', params: { token: token || '' } }"
                >
                <img :src="weeklyTargetBanner" alt="" />
                </router-link>

                <router-link
                v-else-if="statusVal === 3"
                :to="{ name: 'WeeklyTargetPolicyStatus3', params: { token: token || '' } }"
                >
                <img :src="weeklyTargetBanner" alt="" />
                </router-link> -->

            <div v-else>
                <img :src="weeklyTargetBanner" alt="" />
            </div>
        </div>

        <div class="weeklyTarget-boxes">
            <!-- This Week Target summary -->
            <div class="weeklyTarget-box thisWeekTarget">
                <h3 class="d-flex justify-content-between align-items-center weeklyTarget-subHd">
                    This Week Target
                    <span class="startToEndDate">{{ currentWeekStartDate }} To {{ currentWeekEndDate }}</span>
                </h3>
                <div class="weeklyTarget-infoBox">
                    <div class="wt-titleBox d-flex justify-content-between align-items-center">
                        <h5 class="m-0">Total Week Time</h5>
                        <img :src="weeklyTargetInfoIcon" class="wt-infoIcon" alt="" />
                    </div>
                    <div class="wt-timeProgress">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="remainig-time"><i>Consume Time - <b>{{ workingHoursTime }}</b></i></div>
                            <div class="maxTime">
                                <i><b>{{ convertSecondsToHours(CurrentWeekTargetData.total_hours || 0)}}</b></i></div>
                        </div>
                        <div class="wt-progressWrap">
                            <div class="wt-progress">
                                <div class="wt-progressFill" :style="{ width: currentWeek_progressPercentage + '%' }">
                                </div>
                            </div>
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="timeSpend-box">Remaining - <b>{{ remainingTime }}</b></div>
                                <div class="timeSpend-box text-right">Max - <b>{{ convertSecondsToHours(CurrentWeekTargetData.target_per_day_hours || 0) }}/day</b></div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div>
                    <div class="weeklyTarget-infoBox" v-if="(CurrentWeekTargetData.total_peak_hours || 0) !== 0">
                        <div class="wt-titleBox d-flex justify-content-between align-items-center">
                            <h5 class="m-0">Peak Hour Bonus</h5>
                            <img :src="weeklyTargetInfoIcon" class="wt-infoIcon" alt="" />
                        </div>
                        <div class="wt-timeProgress">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="remainig-time"><i>Consume Time - <b>{{ peak_workingHoursTime }}</b></i></div>
                                <div class="maxTime">
                                    <i><b>{{ convertSecondsToHours(CurrentWeekTargetData.total_peak_hours || 0) }}</b></i>
                                </div>
                            </div>
                            <div class="wt-progressWrap">
                                <div class="wt-progress">
                                    <div class="wt-progressFill"
                                        :style="{ width: current_peakWeek_progressPercentage + '%' }"></div>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="timeSpend-box">Remaining - <b>{{ peak_remainingTime }}</b></div>
                                    <div class="timeSpend-box text-right">Max - <b>{{ convertSecondsToHours(CurrentWeekTargetData.target_per_day_peak_hours || 0) }}/day</b></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->

                <!-- Daily Time Report -->
                <div class="dayTimeReport-wrapper currentWeek-dayTimeReport">
                    <h3 class="d-flex justify-content-between align-items-center weeklyTarget-subHd">Time Report :
                    </h3>
                    <div class="tt-calculator-dateWrapper weekDays-listWrapper">
                        <ul>
                            <!-- data rows -->

                            <li v-for="(entry, index) in parsedDailyData" :key="index" :class="{
                                currentdate: entry.day === todayChar && entry.seconds < perDayTarget,
                                oldDate: entry.seconds >= perDayTarget,
                                tt_notComlete: entry.seconds < perDayTarget && entry.day !== todayChar,
                                upcoming_day: upcomingIndices.includes(index)
                            }">
                                <div class="d-flex justify-content-center align-items-center tt-date">{{ entry.day }}</div>

                                <div class="tt-timeBox">Time: <b>{{ formatToHHMM(entry.seconds || 0) }}</b></div>

                                <!-- <div>
                                    <div class="tt-timeBox" v-if="statusVal !== 4 && statusVal !== 5">Peak: 
                                        <b>{{ formatToHHMM(parsedDailyPeak[index]?.seconds || 0)}}</b>
                                    </div>
                                </div> -->
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- Daily Time Report End-->
            </div>

            <!-- Last Week (unchanged) -->
            <div class="weeklyTarget-box lastWeekTarget">
                <div>
                    <h3 class="d-flex justify-content-between align-items-center weeklyTarget-subHd">
                        Last Week Targets
                        <span class="startToEndDate">{{ lastWeekStartDate }} To {{ lastWeekEndDate }}</span>
                    </h3>
                    <div class="weeklyTarget-infoBox">
                        <div class="wt-titleBox d-flex justify-content-between align-items-center">
                            <h5 class="m-0">Week 1</h5>
                            <div class="d-flex align-items-center gap-1">
                                <span class="totlReward-subHD">Total Reward</span>
                                <span class="totlReward-val">
                                    <img :src="beansIcon" class="beansIcon" alt="" />
                                    {{ totalReward }}
                                </span>
                            </div>
                        </div>

                        <div class="wt-timeProgress">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="remainig-time"><i>Consume Time - <b>{{ lastWeek_workingHoursTime }}</b></i>
                                </div>
                                <div class="maxTime"><i><b>{{ convertSecondsToHours(LastWeekTargetData.total_hours || 0)
                                            }}</b></i></div>
                            </div>

                            <div class="wt-progressWrap">
                                <div class="wt-progress">
                                    <div class="wt-progressFill" :style="{ width: lastWeek_progressPercentage + '%' }">
                                    </div>
                                </div>

                                <div class="d-flex justify-content-between position-relative">
                                    <div class="lastWeek_rewardBox" v-if="LastWeekTargetData.reward !== 0">
                                        <div class="d-flex align-items-center gap-1">
                                            <span class="totlReward-subHD">Reward</span>
                                            <span class="totlReward-val"><img :src="beansIcon" class="beansIcon"
                                                    alt="" /> {{ LastWeekTargetData.reward }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="weeklyTarget-infoBox" v-if="(LastWeekTargetData.total_peak_hours || 0) !== 0">
                        <div class="wt-titleBox d-flex justify-content-between align-items-center">
                            <h5 class="m-0">Peak Hour Bonus</h5>
                            <img :src="weeklyTargetInfoIcon" class="wt-infoIcon" alt="" />
                        </div>

                        <div class="wt-timeProgress">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="remainig-time"><i>Consume Time - <b>{{ lastWeek_peak_workingHoursTime
                                            }}</b></i></div>
                                <div class="maxTime"><i><b>{{ convertSecondsToHours(LastWeekTargetData.total_peak_hours
                                            || 0) }}</b></i></div>
                            </div>

                            <div class="wt-progressWrap">
                                <div class="wt-progress">
                                    <div class="wt-progressFill"
                                        :style="{ width: lastWeek_peakWeek_progressPercentage + '%' }"></div>
                                </div>

                                <div class="d-flex position-relative">
                                    <div class="lastWeek_rewardBox" v-if="LastWeekTargetData.peak_reward !== 0">
                                        <div class="d-flex align-items-center gap-1">
                                            <span class="totlReward-subHD">Reward</span>
                                            <span class="totlReward-val"><img :src="beansIcon" class="beansIcon"
                                                    alt="" /> {{ LastWeekTargetData.peak_reward }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->


                    <div class="d-flex justify-content-end showTimeReport-btn" @click="showLastWeekReport = !showLastWeekReport">{{ showLastWeekReport ? 'Hide Time Report' : 'Show Time Report' }}</div>
                    <!-- Daily Time Report -->
                    <div :class="['dayTimeReport-wrapper lastWeek-dayTimeReport', { 'd-none': !showLastWeekReport }]">
                        <h3 class="d-flex justify-content-between align-items-center weeklyTarget-subHd">Time Report :
                        </h3>
                        <div class="tt-calculator-dateWrapper weekDays-listWrapper">
                            <ul v-if="parsedLastDailyData && parsedLastDailyData.length">
                                <li v-for="(entry, index) in parsedLastDailyData" :key="index" :class="{
                                    oldDate: entry.seconds >= perDayTargetLast,
                                    tt_notComlete: entry.seconds < perDayTargetLast
                                }">
                                    <div class="d-flex justify-content-center align-items-center tt-date">{{ entry.day }}</div>
                                    <div class="tt-timeBox">Time: <b>{{ formatToHHMM(entry.seconds || 0) }}</b></div>
                                    <!-- <div class="tt-timeBox" v-if="statusVal !== 4 && statusVal !== 5">Peak: 
                                        <b>{{ formatToHHMM(parsedLastDailyPeak[index]?.seconds || 0)}}</b>
                                    </div> -->
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- Daily Time Report End -->                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import weeklyTargetBanner from '../../assets/images/weeklyTarget-banner.png';
import weeklyTargetInfoIcon from '../../assets/images/weeklyTarget-infoIcon.png';
import beansIcon from '../../assets/images/beansIcon.png';

export default {
    name: 'WeeklyTarget',
    data() {
        return {
            weeklyTargetBanner,
            weeklyTargetInfoIcon,
            beansIcon,
            CurrentWeekTargetData: {}, // object expected from API
            LastWeekTargetData: {},
            statusVal: 1,
            token: '',

            currentWeekStartDate: '',
            currentWeekEndDate: '',
            lastWeekStartDate: '',
            lastWeekEndDate: '',

            workingHoursTime: '',
            remainingTime: '',
            peak_workingHoursTime: '',
            peak_remainingTime: '',

            lastWeek_workingHoursTime: '',
            lastWeek_remainingTime: '',
            lastWeek_peak_workingHoursTime: '',
            lastWeek_peak_remainingTime: '',

            showLastWeekReport: false,
        };
    },

    computed: {
        // build daily arrays (single-letter day representation)
        parsedDailyData() {
            const d = this.CurrentWeekTargetData || {};
            return [
                { day: 'M', seconds: d.monday || 0 },
                { day: 'T', seconds: d.tuesday || 0 },
                { day: 'W', seconds: d.wednesday || 0 },
                { day: 'T', seconds: d.thursday || 0 },
                { day: 'F', seconds: d.friday || 0 },
                { day: 'S', seconds: d.saturday || 0 },
                { day: 'S', seconds: d.sunday || 0 },
            ];
        },

        parsedDailyPeak() {
            const d = this.CurrentWeekTargetData || {};
            return [
                { day: 'M', seconds: d.monday_peak || 0 },
                { day: 'T', seconds: d.tuesday_peak || 0 },
                { day: 'W', seconds: d.wednesday_peak || 0 },
                { day: 'T', seconds: d.thursday_peak || 0 },
                { day: 'F', seconds: d.friday_peak || 0 },
                { day: 'S', seconds: d.saturday_peak || 0 },
                { day: 'S', seconds: d.sunday_peak || 0 },
            ];
        },

        // per-day targets from API
        perDayTarget() {
            return (this.CurrentWeekTargetData && this.CurrentWeekTargetData.target_per_day_hours) || 0;
        },
        perDayPeakTarget() {
            return (this.CurrentWeekTargetData && this.CurrentWeekTargetData.target_per_day_peak_hours) || 0;
        },

        // Last week daily arrays (same single-char days order)
        parsedLastDailyData() {
            const d = this.LastWeekTargetData || {};
            return [
                { day: 'M', seconds: d.monday || 0 },
                { day: 'T', seconds: d.tuesday || 0 },
                { day: 'W', seconds: d.wednesday || 0 },
                { day: 'T', seconds: d.thursday || 0 },
                { day: 'F', seconds: d.friday || 0 },
                { day: 'S', seconds: d.saturday || 0 },
                { day: 'S', seconds: d.sunday || 0 },
            ];
        },

        parsedLastDailyPeak() {
            const d = this.LastWeekTargetData || {};
            return [
                { day: 'M', seconds: d.monday_peak || 0 },
                { day: 'T', seconds: d.tuesday_peak || 0 },
                { day: 'W', seconds: d.wednesday_peak || 0 },
                { day: 'T', seconds: d.thursday_peak || 0 },
                { day: 'F', seconds: d.friday_peak || 0 },
                { day: 'S', seconds: d.saturday_peak || 0 },
                { day: 'S', seconds: d.sunday_peak || 0 },
            ];
        },

        // per-day targets for last week
        perDayTargetLast() {
            return (this.LastWeekTargetData && this.LastWeekTargetData.target_per_day_hours) || 0;
        },
        perDayPeakTargetLast() {
            return (this.LastWeekTargetData && this.LastWeekTargetData.target_per_day_peak_hours) || 0;
        },

        // today's single-char mapping (Sunday=0 => 'S', Monday=1 => 'M', etc.)
        todayChar() {
            const map = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
            return map[new Date().getDay()];
        },

        // progress computations (safe with defaults)
        currentWeek_progressPercentage() {
            const d = this.CurrentWeekTargetData || {};
            const working = d.working_hours || 0;
            const total = d.total_hours || 0;
            if (!total) return 0;
            return Math.min((working * 100) / total, 100);
        },
        current_peakWeek_progressPercentage() {
            const d = this.CurrentWeekTargetData || {};
            const working = d.working_peak_hours || 0;
            const total = d.total_peak_hours || 0;
            if (!total) return 0;
            return Math.min((working * 100) / total, 100);
        },

        lastWeek_progressPercentage() {
            const d = this.LastWeekTargetData || {};
            const working = d.working_hours || 0;
            const total = d.total_hours || 0;
            if (!total) return 0;
            return Math.min((working * 100) / total, 100);
        },
        lastWeek_peakWeek_progressPercentage() {
            const d = this.LastWeekTargetData || {};
            const working = d.working_peak_hours || 0;
            const total = d.total_peak_hours || 0;
            if (!total) return 0;
            return Math.min((working * 100) / total, 100);
        },

        totalReward() {
            const reward = this.LastWeekTargetData?.reward || 0;
            const peakReward = this.LastWeekTargetData?.peak_reward || 0;
            return reward + peakReward;
        },

        upcomingIndices() {
        const list = this.parsedDailyData || [];
        if (!list.length) return [];

        const todayIdx = list.findIndex(item => item.day === this.todayChar);
        if (todayIdx === -1) return [];

        // Collect all future days after today
        return list
            .map((item, index) => ({ ...item, index }))
            .filter(item => item.index > todayIdx && (item.seconds || 0) < (this.perDayTarget || 0))
            .map(item => item.index);
        }
    },

    mounted() {
        this.setWeekDates();
        this.fetchweeklyTargetData();
    },
    watch: {
        '$route.params.token': 'fetchweeklyTargetData'
    },

    methods: {
        setWeekDates() {
            const now = new Date();
            const day = now.getDay();
            const diffToMonday = day === 0 ? -6 : 1 - day;

            const currentMonday = new Date(now);
            currentMonday.setDate(now.getDate() + diffToMonday);
            currentMonday.setHours(0, 0, 0, 0);

            const currentSunday = new Date(currentMonday);
            currentSunday.setDate(currentMonday.getDate() + 6);

            const lastMonday = new Date(currentMonday);
            lastMonday.setDate(currentMonday.getDate() - 7);

            const lastSunday = new Date(currentSunday);
            lastSunday.setDate(currentSunday.getDate() - 7);

            const formatDate = (date) => {
                const pad = (n) => n.toString().padStart(2, '0');
                return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()}`;
            };

            this.currentWeekStartDate = formatDate(currentMonday);
            this.currentWeekEndDate = formatDate(currentSunday);
            this.lastWeekStartDate = formatDate(lastMonday);
            this.lastWeekEndDate = formatDate(lastSunday);
        },

        fetchweeklyTargetData() {
            // read token safely
            const tokenParam = this.$route.params.token || this.$route.query.token || '';
            this.token = typeof tokenParam === 'string' ? tokenParam.replace(/^token=/, '') : tokenParam;

            axios.get(`api/freetarget-weekly`, {
                headers: {
                    Authorization: `Bearer ${this.token}`
                }
            })
                .then(response => {
                    const res = response.data.result || {};
                    this.CurrentWeekTargetData = res.current_week_data || {};
                    this.LastWeekTargetData = res.last_week_data || {};
                    this.statusVal = res.status || 1;

                    // compute and format times
                    this.remainingSeconds = (this.CurrentWeekTargetData.total_hours || 0) - (this.CurrentWeekTargetData.working_hours || 0);
                    this.peak_remainingSeconds = (this.CurrentWeekTargetData.total_peak_hours || 0) - (this.CurrentWeekTargetData.working_peak_hours || 0);

                    this.updateRemainingTime();
                    this.updateWorkingTimeFormate();
                    this.peak_updateRemainingTime();
                    this.peak_updateWorkingTimeFormate();

                    this.lastWeek_remainingSeconds = (this.LastWeekTargetData.total_hours || 0) - (this.LastWeekTargetData.working_hours || 0);
                    this.lastWeek_peak_remainingSeconds = (this.LastWeekTargetData.total_peak_hours || 0) - (this.LastWeekTargetData.working_peak_hours || 0);

                    this.lastWeek_updateRemainingTime();
                    this.lastWeek_updateWorkingTimeFormate();
                    this.lastWeek_peak_updateRemainingTime();
                    this.lastWeek_peak_updateWorkingTimeFormate();
                })
                .catch(error => {
                    console.error("Error Fetching weekly target data", error);
                });
        },

        convertSecondsToHours(seconds) {
            const hours = Math.floor((seconds || 0) / 3600);
            return `${hours} hrs`;
        },

        formatTime(seconds) {
            seconds = seconds || 0;
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            const secs = seconds % 60;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
        },

        formatToHHMM(seconds) {
            seconds = seconds || 0;
            const hrs = String(Math.floor(seconds / 3600)).padStart(2, '0');
            const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
            return `${hrs}:${mins}`;
        },

        updateWorkingTimeFormate() {
            const w = this.CurrentWeekTargetData.working_hours || 0;
            this.workingHoursTime = this.formatTime(w);
        },
        updateRemainingTime() {
            this.remainingTime = this.formatTime(this.remainingSeconds >= 0 ? this.remainingSeconds : 0);
        },

        peak_updateWorkingTimeFormate() {
            const w = this.CurrentWeekTargetData.working_peak_hours || 0;
            this.peak_workingHoursTime = this.formatTime(w);
        },
        peak_updateRemainingTime() {
            this.peak_remainingTime = this.formatTime(this.peak_remainingSeconds >= 0 ? this.peak_remainingSeconds : 0);
        },

        lastWeek_updateWorkingTimeFormate() {
            const w = this.LastWeekTargetData.working_hours || 0;
            this.lastWeek_workingHoursTime = this.formatTime(w);
        },
        lastWeek_updateRemainingTime() {
            this.lastWeek_remainingTime = this.formatTime(this.lastWeek_remainingSeconds >= 0 ? this.lastWeek_remainingSeconds : 0);
        },

        lastWeek_peak_updateWorkingTimeFormate() {
            const w = this.LastWeekTargetData.working_peak_hours || 0;
            this.lastWeek_peak_workingHoursTime = this.formatTime(w);
        },
        lastWeek_peak_updateRemainingTime() {
            this.lastWeek_peak_remainingTime = this.formatTime(this.lastWeek_peak_remainingSeconds >= 0 ? this.lastWeek_peak_remainingSeconds : 0);
        },
    }
};
</script>
